import React, { Component } from "react";
import { Row, Col, Space, Image } from "antd";
import { Link } from "react-router-dom";
import "../../App.css";

export default class Ciga extends Component {
  render() {
    const arr = [];
    for (let i = 1; i < 9; i++) {
      arr[i] = i;
    }
    return (
      <>
        <Row>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row justify="center">
              <Col span={24} className="paddLR10">
                <Link className="breadCrumbText link" to="/home">
                  Home
                </Link>
                &nbsp;&gt;&nbsp;
                <Link className="breadCrumbText link" to="/gameart">
                  Game Art Projects
                </Link>
              </Col>
              <Col span={24} className="cigaTitle">
                48 Hours CIGA Game Jam
              </Col>
              <Col span={24} className="cigaSubTitle">
                July 2024
              </Col>
              <Col span={24} className="paddTop60"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row justify="center">
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row>
              <Col
                xs={{ span: 24, order: 1 }}
                sm={{ span: 24, order: 1 }}
                md={{ span: 14, order: 1 }}
                lg={{ span: 14, order: 1 }}
                xl={{ span: 14, order: 1 }}
              >
                <iframe
                  src="https://player.bilibili.com/player.html?isOutside=true&aid=112745995373166&bvid=BV1uShDehEPf&cid=500001608142740&p=1"
                  id="biliFrame"
                  scrolling="no"
                  border="0"
                  frameBorder="no"
                  framespacing="0"
                  allowFullScreen={true}
                />
              </Col>
              <Col
                xs={{ span: 24, order: 4 }}
                sm={{ span: 24, order: 4 }}
                md={{ span: 10, order: 2 }}
                lg={{ span: 10, order: 2 }}
                xl={{ span: 10, order: 2 }}
              >
                <div className="biliTxt">
                  During a the game jam, I led and collaborated as an artist
                  with other talented creators to develop "
                  <span className="fBold fIta">Endless Reminiscence</span>," a
                  game exploring the perspective of an elderly woman with
                  Alzheimer’s, driven by her limitless love for her children. We
                  decided to use a nostalgic, children art style with 1980
                  vintage environments to reflect her fading memories. The
                  recurring scenes symbolized her struggle. The gameplay cycled
                  through fragmented memories, emphasizing her battle between
                  limited memory and unlimited love.
                </div>
              </Col>
              <Col
                xs={{ span: 24, order: 2 }}
                sm={{ span: 24, order: 2 }}
                md={{ span: 24, order: 3 }}
                lg={{ span: 24, order: 3 }}
                xl={{ span: 24, order: 3 }}
                className="paddTop20 paddLR10"
              >
                <a
                  href="https://wittydoma.itch.io/cgj2024"
                  target="_blank"
                  className="link"
                >
                  Online PlayLink
                </a>
              </Col>
              <Col
                xs={{ span: 24, order: 3 }}
                sm={{ span: 24, order: 3 }}
                md={{ span: 0, order: 4 }}
                lg={{ span: 0, order: 4 }}
                xl={{ span: 0, order: 4 }}
                className="paddTop20"
              ></Col>
            </Row>
            <Row>
              <Col span={24} className="rH50"></Col>
              <Col
                span={24}
                className="f2EM fAEL paddLR10 paddTop40 fBold color72"
              >
                Background Design
              </Col>
              <Col span={24} className="paddLR10 color157">
                Collaborated with another artist to complete
              </Col>
              <Col span={24} className="paddTop20">
                <Space direction="vertical" size="large">
                  {arr.map((item) => {
                    return (
                      <Image
                        alt={`Ciga Game ${item} Image`}
                        src={`${process.env.PUBLIC_URL}/images/jpg/Ciga_${item}.jpg`}
                        className="img100"
                        loading="lazy"
                        preview={false}
                        placeholder={
                          <Image
                            src={`${process.env.PUBLIC_URL}/images/jpg/Ciga_${item}_blur.jpg`}
                            className="img100"
                            preview={false}
                          />
                        }
                      />
                    );
                  })}
                </Space>
              </Col>
              <Col span={24} className="paddTop40"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row>
          <Col className="rH100"></Col>
        </Row>
      </>
    );
  }
}
